import { render } from "./TraitRanksApesTraitsCard.vue?vue&type=template&id=c9641e94"
import script from "./TraitRanksApesTraitsCard.vue?vue&type=script&lang=js"
export * from "./TraitRanksApesTraitsCard.vue?vue&type=script&lang=js"

import "./TraitRanksApesTraitsCard.vue?vue&type=style&index=0&id=c9641e94&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__